import { Injectable } from '@angular/core';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
declare var $: any;

@Injectable()
export class DatatransferService {
  appcode: any;
  userid: any;
  logintype: any;
  user_email: any;

  // new veva service apis

  // incresol local server
  // Coreappconstant = 'https://discvavecore.incresol.com/core/';
  // appconstantpdp = 'https://discvavecore.incresol.com/DaimPDP/pdp/';
  // appconstant = 'https://discvavecore.incresol.com/disc/';
  // appconstantpmp = "https://discvavecore.incresol.com/DaimPMP/pmp/";
  // appconstantispr = "https://discvavecore.incresol.com/DaimISPR/ispr/";
  // appconstantpackaging = 'https://discvavecore.incresol.com/DaimPackaging/pack/';
  // appconstantgp = 'https://discvavecore.incresol.com/DaimGatepass/gp/';
  // appconstantrakto = 'https://discvavecore.incresol.com/DaimRAKTO/';
  // appconstantkem = 'https://discvavecore.incresol.com/DaimKEM/';
  // appconstantkys = 'https://discvavecore.incresol.com/DaimKYS/';
  // appconstantIA = 'https://discvavecore.incresol.com/DaimIA/ia/';
  // appconstantVAVE = 'https://discvavecore.incresol.com/veva/';
  // appconstantNPP = 'https://discvavecore.incresol.com/DaimNPP/npp/';
  // DaimQm = 'https://discvavecore.incresol.com/DaimQm/qm/';
  // DaimSuppDirectory = 'https://discvavecore.incresol.com/DaimSuppDirectory/'
  // certificationCR = 'https://discvavecore.incresol.com/DICVDISC/certifi-status/'
  // globalurl = "https://discvavecore.incresol.com/dicvscar/Daimpackaging";
  

  // local server dev VEVA APIS 
  // Coreappconstant = 'http://localhost:8080/DaimVeva/core/';
  // appconstantpdp = 'http://localhost:8080/DaimPDP/pdp/';
  // appconstant = 'http://localhost:8080/DaimVeva/disc/';
  // appconstantpmp = "http://localhost:8080/DaimPMP/pmp/";
  // appconstantispr = "http://localhost:8080/DaimISPR/ispr/";
  // appconstantpackaging = 'http://localhost:8080/DaimPackaging/pack/';
  // appconstantgp = 'http://localhost:8080/DaimGatepass/gp/';
  // appconstantrakto = 'http://localhost:8080/DaimRAKTO/';
  // appconstantkem = 'http://localhost:8080/DaimKEM/';
  // appconstantkys = 'http://localhost:8080/DaimKYS/';
  // appconstantIA = 'http://localhost:8080/DaimIA/ia/';
  // appconstantVAVE = 'http://localhost:8080/DaimVeva/veva/';
  // appconstantNPP = 'http://localhost:8080/DaimNPP/npp/';
  // DaimQm = 'http://localhost:8080/DaimQm/qm/';
  // DaimSuppDirectory = 'http://localhost:8080/DaimSuppDirectory/'
  // certificationCR = 'http://localhost:8080/DICVDISC/certifi-status/'
  // globalurl = "http://localhost:8080/dicvscar/Daimpackaging";


  // new daimler veva portal service apis
 //  qa server
//  Coreappconstant = 'http://10.40.2.4:8080/DaimVeva/core/';
//  appconstantpdp = 'http://10.40.2.4:8080/DaimPDP/pdp/';
//  appconstant = 'http://10.40.2.4:8080/DaimVeva/disc/';
//  appconstantpmp = "http://10.40.2.4:8080/DaimPMP/pmp/";
//  appconstantispr = "http://10.40.2.4:8080/DaimISPR/ispr/";
//  appconstantpackaging = 'http://10.40.2.4:8080/DaimPackaging/pack/';
//  appconstantgp = 'http://10.40.2.4:8080/DaimGatepass/gp/';
//  appconstantrakto = 'http://10.40.2.4:8080/DaimRAKTO/';
//  appconstantkem = 'http://10.40.2.4:8080/DaimKEM/';
//  appconstantkys = 'http://10.40.2.4:8080/DaimKYS/';
//  appconstantIA = 'http://10.40.2.4:8080/DaimIA/ia/';
//  appconstantVAVE = 'http://10.40.2.4:8080/DaimVeva/veva/';
//  appconstantNPP = 'http://10.40.2.4:8080/DaimNPP/npp/';
//  DaimQm = 'http://10.40.2.4:8080/DaimQm/qm/';
//  DaimSuppDirectory = 'http://10.40.2.4:8080/DaimSuppDirectory/'
//  certificationCR = 'http://10.40.2.4:8080/DICVDISC/certifi-status/'
//  globalurl = "http://10.40.2.4:8080/dicvscar/Daimpackaging";

// new daimler veva portal service apis
 //  prod server
//  Coreappconstant = 'http://10.41.2.4:8080/DaimVeva/core/';
//  appconstantpdp = 'http://10.41.2.4:8080/DaimPDP/pdp/';
//  appconstant = 'http://10.41.2.4:8080/DaimVeva/disc/';
//  appconstantpmp = "http://10.41.2.4:8080/DaimPMP/pmp/";
//  appconstantispr = "http://10.41.2.4:8080/DaimISPR/ispr/";
//  appconstantpackaging = 'http://10.41.2.4:8080/DaimPackaging/pack/';
//  appconstantgp = 'http://10.41.2.4:8080/DaimGatepass/gp/';
//  appconstantrakto = 'http://10.41.2.4:8080/DaimRAKTO/';
//  appconstantkem = 'http://10.41.2.4:8080/DaimKEM/';
//  appconstantkys = 'http://10.41.2.4:8080/DaimKYS/';
//  appconstantIA = 'http://10.41.2.4:8080/DaimIA/ia/';
//  appconstantVAVE = 'http://10.41.2.4:8080/DaimVeva/veva/';
//  appconstantNPP = 'http://10.41.2.4:8080/DaimNPP/npp/';
//  DaimQm = 'http://10.41.2.4:8080/DaimQm/qm/';
//  DaimSuppDirectory = 'http://10.41.2.4:8080/DaimSuppDirectory/'
//  certificationCR = 'http://10.41.2.4:8080/DICVDISC/certifi-status/'
//  globalurl = "http://10.41.2.4:8080/dicvscar/Daimpackaging";


//new proxy apis

Coreappconstant       = environment.apiBaseUrl + '/DaimVeva/core/';
appconstantpdp        = environment.apiBaseUrl + '/DaimPDP/pdp/';
appconstant           = environment.apiBaseUrl + '/DaimVeva/disc/';
appconstantpmp        = environment.apiBaseUrl + '/DaimPMP/pmp/';
appconstantispr       = environment.apiBaseUrl + '/DaimISPR/ispr/';
appconstantpackaging  = environment.apiBaseUrl + '/DaimPackaging/pack/';
appconstantgp         = environment.apiBaseUrl + '/DaimGatepass/gp/';
appconstantrakto      = environment.apiBaseUrl + '/DaimRAKTO/';
appconstantkem        = environment.apiBaseUrl + '/DaimKEM/';
appconstantkys        = environment.apiBaseUrl + '/DaimKYS/';
appconstantIA         = environment.apiBaseUrl + '/DaimIA/ia/';
appconstantVAVE       = environment.apiBaseUrl + '/DaimVeva/veva/';
appconstantNPP        = environment.apiBaseUrl + '/DaimNPP/npp/';
DaimQm                = environment.apiBaseUrl + '/DaimQm/qm/';
DaimSuppDirectory     = environment.apiBaseUrl + '/DaimSuppDirectory/';
certificationCR       = environment.apiBaseUrl + '/DICVDISC/certifi-status/';
globalurl             = environment.apiBaseUrl + '/dicvscar/Daimpackaging';


// getsession = JSON.parse(localStorage.getItem("sevinvoicesession"));
  constructor(private router: Router,) {

  }
  public session: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);
  getsession(value) {
    this.session.next(value);
  }

  showNotification(from, align, msg, type) {

    $.notify({
      icon: 'notifications',
      message: msg

    }, {
        type: type,
        timer: 2000,
        placement: {
          from: from,
          align: align
        }
      });
  }

  // appcode = 'vignesshgmailcom'
  // userid = 'users1';
  // logintype = 'superuser';
  //  getapi(value) {
  //      this.apidetail.next(value);
  //  }
  partid: any;
  setpartid(partid) {
    this.partid = partid;
    console.log(this.partid)
  }
  pmpProjectid = null;
  pmpProjectname = null;
  pmppartid = null;
  pmpStatusProjectid = null;
  pmpStatusProjectName=null;
  devstatusmailteam = [];
  devstatuspartid = [];
  tabflag=false
  isprReport(value){
    this.tabflag = value
   
  }
  StatusColor(key){

    var colorsMap = {
        "Requester L4 Approved":'#EAEAEA',
        "SM L4 Rejected":'#FF2E2E',
        "Completed":'#72AF00',
        "IPL L4 Approved":'#A0A0A0',
        "SM Approval Pending":'#ffe55c',
        "SM L4 Approval Pending":'#ffe55c',
        "Warehouse Manager Approval Pending":'#ffe55c',
        "Warehouse L4 Approval Pending":'#ffe55c',
        "Warehouse Manager Entry Pending":'#ffe55c',
        "Material Gate Entry Pending":'#ffe55c',
        "Reciept Confirmation Pending":"#ffe55c",
        "Reciept Confirmed":"#72AF00",
        "Gate Inward Entry Pending":"#ffe55c",
        "Gate Outward Entry Pending":"#ffe55c",
        "Rejected by SM L4":"#FF2E2E",
        "Rejected by SM":"#FF2E2E",
        "NPM Manager Approval Pending":"#ffe55c",
        "Rejected by NPM Manager":"#FF2E2E",
        "Rejected by Warehouse Manager":"#FF2E2E",
        "Rejected by Warehouse L4":"#FF2E2E",
        "Closed":"#72AF00",
        "Requester L4 Approval Pending":"#ffe55c",
        "Rejected by Requester L4":'#FF2E2E',
        "Requester L3 Approval Pending":"#ffe55c",
        "SM L3 Approval Pending":"#ffe55c",
        "Rejected by SM L3":"#FF2E2E",
    }
    var colorsVal = "";
    if(colorsMap.hasOwnProperty(key)){
        colorsVal = colorsMap[key];
    }else{
        colorsVal = key;
    }

    return colorsVal;
  }
  SColor(key){
    var colorsMap = {
        "Requester L4 Approved":'#000000',
        "SM L4 Rejected":'#fff',
        "Completed":'#fff',
        "IPL L4 Approved":'#fff',
        "SM Approval Pending":'#000000',
        "SM L4 Approval Pending":'#000000',
        "Warehouse Manager Approval Pending":'#000000',
        "Warehouse L4 Approval Pending":'#000000',
        "Warehouse Manager Entry Pending":'#000000',
        "Material Gate Entry Pending":'#000000',
        "Reciept Confirmation Pending":"#000000",
        "Reciept Confirmed":"#ffffff",
        "Gate Inward Entry Pending":"#000000",
        "Gate Outward Entry Pending":"#000000",
        "Rejected by SM L4":"#fff",
        "Rejected by SM":"#fff",
        "NPM Manager Approval Pending":"#000000",
        "Rejected by NPM Manager":"#fff",
        "Rejected by Warehouse Manager":"#fff",
        "Rejected by Warehouse L4":"#fff",
        "Closed":"#fff",
        "Requester L4 Approval Pending":"#000000",
        "Rejected by Requester L4":"#fff",
        "Requester L3 Approval Pending":"#000000",
        "SM L3 Approval Pending":"#000000",
        "Rejected by SM L3":"#FF2E2E",
    }
    var colorsVal = "";
    if(colorsMap.hasOwnProperty(key)){
        colorsVal = colorsMap[key];
    }else{
        colorsVal = key;
    }

    return colorsVal;
  }

  ktoStatusColor(key){

    var colorsMap = {
        "Vendor Receipt Confirmed":'#4caf50',
        "Rejected by SM":'#FF2E2E',
        "Completed":'#72AF00',
        "IPL L4 Approved":'#A0A0A0',
        "SM Approval Pending":'#ffe55c',
        "Vendor Receipt Confirm Pending":'#ffe55c',
        "Warehouse Manager Approval Pending":'#ffe55c',
        "IBL Approval Pending":"#ffe55c",
        "Draft":"#ffe55c",
        "Warehouse Manager Dispatch Pending":"#ffe55c",
        "SM L4 Approval Pending":"#ffe55c",
        "Rejected by SM L4":'#FF2E2E',
    }
    var colorsVal = "";
    if(colorsMap.hasOwnProperty(key)){
        colorsVal = colorsMap[key];
    }else{
        colorsVal = key;
    }

    return colorsVal;
  }
  ktoSColor(key){
    var colorsMap = {
        "Vendor Receipt Confirmed":'#fff',
        "Rejected by SM":'#fff',
        "Completed":'#fff',
        "IPL L4 Approved":'#fff',
        "SM Approval Pending":'#000000',
        "Vendor Receipt Confirm Pending":'#000000',
        "Warehouse Manager Approval Pending":'#000000',
        "IBL Approval Pending":"#000000",
        "Draft":"#000000",
        "Warehouse Manager Dispatch Pending":"#000000",
        "SM L4 Approval Pending":"#000000",
        "Rejected by SM L4":'#fff',
        
    }
    var colorsVal = "";
    if(colorsMap.hasOwnProperty(key)){
        colorsVal = colorsMap[key];
    }else{
        colorsVal = key;
    }

    return colorsVal;
  }
  pdf_generator_fun(svg_) {
    var width = 600;
    var height = 600;
    var canvas = document.createElement('canvas');
    // get canvas context for drawing on canvas
    var context = canvas.getContext('2d');
    // set canvas size
    canvas.width = width;
    canvas.height = height;
    // create image in memory(not in DOM)
    var image = new Image();
    var img = new Image();
    image.onload = function () {
      context.clearRect(0, 0, width, height);
      context.drawImage(image, 0, 0, width, height);
      var pngData = canvas.toDataURL('image/' + "png");

      img.src = pngData;
      let set_base64 = pngData.split(",")
      localStorage.setItem("base64_svg_to_png_url", set_base64[1]);
    };
    image.src = svg_;
  }
  isInvalid(formName:FormGroup,controlName: string) {
    let getform = formName
    const control = getform.get(controlName);
    return control && control.invalid && (control.dirty || control.touched);
  }
  public markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
}
}
